import { LIST_LOCALE_NOT_SUPPORT } from '@/constants/date-mode-languages';
import {
  COUNTRY,
  END_DATE_MARKER,
  FLAG,
  PREP_END_DATE_MARKER,
  PREP_START_DATE_MARKER,
  START_DATE_MARKER,
  TIME_COUNTDOWN_MARKER,
  ZIPCODE,
} from '@/constants/string';
import { selectedLanguageRuleSelector } from '@/redux/slice/languageRule.slice';
import { dataSettingsSelector } from '@/redux/slice/settings.slice';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import translate from 'translate';

const useTranslate = () => {
  const dataSettings = useSelector(dataSettingsSelector);
  const currentLanguageRule = useSelector(selectedLanguageRuleSelector);
  const variablesToSkip = useMemo(
    () => [
      { value: TIME_COUNTDOWN_MARKER, code: '∅' },
      { value: PREP_START_DATE_MARKER, code: '⊖' },
      { value: PREP_END_DATE_MARKER, code: '↟' },
      { value: START_DATE_MARKER, code: '⇔' },
      { value: END_DATE_MARKER, code: '≬' },
      { value: COUNTRY, code: '⊆' },
      { value: FLAG, code: '∏' },
      { value: ZIPCODE, code: '∞' },
      { value: '<b>', code: '⊃' },
      { value: '</b>', code: '≤' },
      { value: '<strong>', code: '≥' },
      { value: '</strong>', code: '⅋' },
      { value: '<i>', code: '∩' },
      { value: '</i>', code: '±' },
      { value: '<font>', code: '∓' },
      { value: '</font>', code: '√' },
      { value: '<span>', code: '∛' },
      { value: '</span>', code: '∜' },
    ],
    [],
  );

  const getSupportedLocale = (languageCode: string) => {
    if (LIST_LOCALE_NOT_SUPPORT.includes(languageCode)) {
      if (languageCode.includes('-')) {
        return languageCode.split('-')[0];
      }
      return;
    }
    return languageCode;
  };

  const isShowTranslate = useMemo(
    () => getSupportedLocale(dataSettings.date_locale) && getSupportedLocale(currentLanguageRule.codeLanguage),
    [currentLanguageRule.codeLanguage, dataSettings.date_locale],
  );

  const translateText = async (text: string, from?: string, to?: string) => {
    if (!text) return '';
    let inputFrom = getSupportedLocale(from || dataSettings.date_locale);
    let inputTo = getSupportedLocale(to || currentLanguageRule.codeLanguage);
    if (!inputFrom || !inputTo) return '';

    let modifiedText = text;
    variablesToSkip.forEach((variable) => {
      modifiedText = modifiedText.replaceAll(variable.value, variable.code);
    });

    try {
      let res = await translate(modifiedText, {
        from: inputFrom,
        to: inputTo,
      });

      variablesToSkip.forEach((variable) => {
        res = res.replaceAll(variable.code, variable.value);
      });

      res = res
        .replaceAll('< b', '<b')
        .replaceAll('< font', '<font')
        .replaceAll('< span', '<span')
        .replaceAll('</ strong', '</strong');

      return res;
    } catch (error) {
      console.error('Translation error:', error);
      return '';
    }
  };

  return { translateText, isShowTranslate };
};

export default useTranslate;
